import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { ExportInterfaceEmailTemplateDTO } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { EmailTemplatesOverviewComponent } from '../../email-templates-overview/email-templates-overview.component';
import { EmailFormComponent } from '../../../../../base/shared/email-form/email-form.component';

@Component({
    selector: 'app-configuration-form-email',
    templateUrl: './configuration-form-email.component.html',
    styleUrls: ['./configuration-form-email.component.scss'],
    imports: [
        EmailFormComponent,
        DialogModule,
        EmailTemplatesOverviewComponent,
        TranslateModule,
    ]
})
export class ConfigurationFormEmailComponent {
  @ViewChild("loadTemplateDialog")
  public dialog: DialogComponent;

  public selectedTemplate: ExportInterfaceEmailTemplateDTO;

  constructor(
    private configurationFormService: ConfigurationFormCoordinatorService,
  ) { }

  public get configurationFormEmail(): UntypedFormGroup {
    return this.configurationFormService.configurationFormEmail;
  }

  public loadFromTemplate() {
    this.dialog.show();
  }

  public cancelClicked() {
    this.selectedTemplate = null;
    this.dialog.hide();
  }

  public okClicked() {
    if (this.selectedTemplate) {
      this.configurationFormService.configurationFormEmail.setValue({
        senderName: this.selectedTemplate.senderName,
        subject: this.selectedTemplate.subject,
        textHTML: this.selectedTemplate.textHTML,
        emailAccountId: this.selectedTemplate.emailAccountId,
      });
    }
    this.selectedTemplate = null;
    this.dialog.hide();
  }

  public templateSelected(selectedEmailTemplate: ExportInterfaceEmailTemplateDTO) {
    this.selectedTemplate = selectedEmailTemplate;
  }

  public templateSelectedAndClose(selectedEmailTemplate: ExportInterfaceEmailTemplateDTO) {
    this.selectedTemplate = selectedEmailTemplate;
    this.okClicked();
  }

  public onOpen(args: any): void {
    //Preventing the default dialog focus
    args.preventFocus = true;
  }
}
